$(document).ready(function() {
    
    var effect = null;
    var canvas = null;

    function updateListings() {
        $('.px-listing').hide();

        if (effect && canvas) {
            $('.px-listing.px-' + canvas + '.px-' + effect).show();
        } 
        else if (effect) {
            $('.px-listing.px-' + effect).show();
        }
        else if (canvas) {
            $('.px-listing.px-' + canvas).show();
        }
        else {
            $('.px-listing').show();
        }
    }


    $('.effect-dropdown').on('change', function() {
        effect = $(this).val().trim();
        if (effect === '') {
            effect = null;
        }
        updateListings();
    });
    $('.canvas-dropdown').on('change', function() {
        canvas = $(this).val().trim();
        if (canvas === '') {
            canvas = null;
        }
        updateListings();
    });

    $(window).on('click', function(e) {
        if ($(e.target).is('#productImageModal')) {
            closeModal();
        }
    });

});

function ignore(ev)
{
    ev.preventDefault();
}

const bnwSmallImages = [
    'assets/images/package/bnw-small-1.jpg',
    'assets/images/package/bnw-small-2.jpg',
    'assets/images/package/bnw-small-3.jpg'
];

const bnwMediumImages = [
    'assets/images/package/bnw-medium-1.jpg',
    'assets/images/package/bnw-medium-2.jpg',
    'assets/images/package/bnw-medium-3.jpg'
];

const retroSmallImages = [
    'assets/images/package/retro-small-1.jpg',
    'assets/images/package/retro-small-2.jpg',
    'assets/images/package/retro-small-3.jpg'
];

const retroMediumImages = [
    'assets/images/package/retro-medium-1.jpg',
    'assets/images/package/retro-medium-2.jpg',
    'assets/images/package/retro-medium-3.jpg'
];

const popSmallImages = [
    'assets/images/package/pop-small-1.jpg',
    'assets/images/package/pop-small-2.jpg',
    'assets/images/package/pop-small-3.jpg'
];

const popMediumImages = [
    'assets/images/package/pop-medium-1.jpg',
    'assets/images/package/pop-medium-2.jpg',
    'assets/images/package/pop-medium-3.jpg'
];

let currentImageIndex = 0;
var currentImages = [];

function openModal(imgs) {
    currentImageIndex = 0;
    currentImages = imgs;
    $('#productImageModal').fadeIn();
    $('#productCarouselImage').attr('src', currentImages[currentImageIndex]);
}

function closeModal() {
    $('#productImageModal').fadeOut();
    currentImages = [];
}

function nextImage() {
    currentImageIndex = (currentImageIndex + 1) % currentImages.length;
    $('#productCarouselImage').attr('src', currentImages[currentImageIndex]);
}

function prevImage() {
    currentImageIndex = (currentImageIndex - 1 + currentImages.length) % currentImages.length;
    $('#productCarouselImage').attr('src', currentImages[currentImageIndex]);
}
